"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZE = void 0;
exports.SIZE = {
    XS: 'XS',
    SM: 'SM',
    MD: 'MD',
    LG: 'LG',
    XL: 'XL',
    '2XL': '2XL',
    '3XL': '3XL',
    '4XL': '4XL',
    '5XL': '5XL'
};
//# sourceMappingURL=size.js.map